import { z } from 'zod';
import { STATIC_WIDGET_IDS } from '~/atoms/fundAnalyticsAtom';

export const DYNAMIC_WIDGET_IDS = ['dynamic'] as const;

export type DynamicWidgetIds = (typeof DYNAMIC_WIDGET_IDS)[number];

export const DYNAMIC_WIDGET_TYPES = [
  'dynamic_table',
  'dynamic_histogram',
  'dynamic_pie_chart',
] as const;

export type DynamicWidgetTypes = (typeof DYNAMIC_WIDGET_TYPES)[number];

export const WIDGET_IDS = [
  ...STATIC_WIDGET_IDS,
  ...DYNAMIC_WIDGET_IDS,
] as const;

const widgetIdsSchema = z.enum(WIDGET_IDS);

export type WidgetIds = z.infer<typeof widgetIdsSchema>;

const dynamicWidgetMetadataSchema = z.object({
  renderComponent: z.enum(DYNAMIC_WIDGET_TYPES),
  props: z
    .object({
      columns: z.array(
        z.object({
          label: z.string(),
        }),
      ),
    })
    .optional(),
  query: z.string(),
  shortDescription: z.string().optional(),
  isAggregate: z.boolean(),
});

const staticWidgetIdSchema = z.enum(STATIC_WIDGET_IDS);
const dynamicWidgetIdSchema = z.enum(DYNAMIC_WIDGET_IDS);

const staticWidgetSchema = z.object({
  id: z.string().uuid(),
  name: staticWidgetIdSchema,
  metadata: z.undefined().optional(),
});

const dynamicWidgetSchema = z.object({
  id: z.string().uuid(),
  name: dynamicWidgetIdSchema,
  metadata: dynamicWidgetMetadataSchema,
});

export const widgetSchema = z.discriminatedUnion('name', [
  staticWidgetSchema,
  dynamicWidgetSchema,
]);

export type Widget = z.infer<typeof widgetSchema>;
